import React, {PureComponent} from 'react';
import './thirdparty.scss';
import pubsub from 'common/js/pubsub';
import loginUtil from 'common/js/login';

export default class Thirdparty extends PureComponent {
	constructor(props) {
		super(props);

		this.toLogin = this.toLogin.bind(this);
	}

	toLogin(e) {
		let target = e.currentTarget,
			type = target.getAttribute('data-type');
		loginUtil.thirdLogin({
			style: 2,
			type: type,
			success: function(res) {
				loginUtil.refreshUserInfo();
				pubsub.publish("showSuccessTips", {
					msg: '登录成功'
				});
			},
			fail: function(res) {
				pubsub.publish("hideLogin");
				pubsub.publish("showPayTips", {
					type: 'fail',
					note:  '',
					txt: '登录失败，请重试'
				});
			}
		})
	}

	render() {
		return (
			<div id="J-third_wrap" className="m-thirdparty">
				<h3><em>快捷登录</em></h3>
				<div className="m-thirdparty_list">
					<a href="javascript:void(0)" className="qq" data-type="qq" onClick={this.toLogin}></a>
					<a href="javascript:void(0)" className="weibo" data-type="wb" onClick={this.toLogin}></a>
				</div>

				<p className="usearg">使用即为同意<a href="http://zc.yy.com/license.html" target="_blank">《用户协议》</a></p>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/views/login/thirdparty/Thirdparty.jsx